<div class="session-timeout-container" (mouseup)="$event.stopPropagation()" (click)="$event.stopPropagation()"
    (touchstart)="$event.stopPropagation()">
    <p-dialog header="Session Timeout" [modal]="true" [(visible)]="visible" (onHide)="onDialogHide()"
        [breakpoints]="{ '2400px': '50vw','1024px': '70vw','575px': '90vw' }">
        <ng-template pTemplate="header">
            <div class="flex flex-1 align-items-center justify-content-center session-header">Session Timeout</div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="pt-5 flex flex-column justify-content-center align-items-center gap-5">
                <div>
                    <span class="session-expire-title">Your session will expire in {{ displayMinutes }}.</span>
                </div>
                <div>
                    <span class="session-timer">{{ displayTimer }}</span>
                </div>
                <div>
                    <span class="session-note">
                        For your security, your session will end in {{ displayMinutes }} due to inactivity. To keep working, simply interact with the page or click below to stay signed in.
                    </span>
                </div>
                <div class="w-full flex justify-content-between align-items-center">
                    <p-button label="LOG OUT NOW" [link]="true" (onClick)="onLogoutClicked()"
                        styleClass="session-logout-btn" />
                    <p-button label="STAY LOGGED IN" (onClick)="onContinueClicked()"
                        styleClass="p-button-rounded p-button-lg" />
                </div>
            </div>
        </ng-template>
    </p-dialog>
</div>
